var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("LayoutPublic", [
    _c("p", { staticClass: "mb-4" }, [_vm._v(_vm._s(_vm.textInfo))]),
    _vm._v(" "),
    _c("div", { class: ["alert alert-" + _vm.validationState] }, [
      _vm.loading
        ? _c(
            "div",
            [
              _c("UiSpinner"),
              _vm._v(
                "\n            " + _vm._s(_vm.confirmLabel) + "\n        "
              ),
            ],
            1
          )
        : _c("div", [
            _vm.success
              ? _c("div", [
                  _c("i", { staticClass: "fa fa-check mr-2" }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.confirmSuccessLabel) +
                      "\n            "
                  ),
                ])
              : _c("div", [
                  _c("i", { staticClass: "fa fa-exclamation-triangle mr-2" }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.errorMessage) +
                      "\n            "
                  ),
                ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }